import NotFoundPage from '@brands/Dashboard/NotFoundPage/NotFoundPage';
import { selectAuth } from '@brands/store/selectors/auth';
import { AuthState } from '@brands/store/slices/authSlice';
import React from 'react';

import { useAppSelector } from '../../../../hooks/useReduxHook';
import { UserRoleName } from '../../../../services/identity/types/UserProfile';
import AdditionalInformation from './AdditionalInformation';

const AdditionalInformationValidation: React.FC = () => {
  let component: JSX.Element;
  const user: AuthState = useAppSelector(selectAuth);

  switch (user.userInfo?.role.name) {
    case UserRoleName.Patient:
    case UserRoleName.CareAdvisor:
    case UserRoleName.OrganizationAdmin:
    case UserRoleName.SuperAdmin:
    case UserRoleName.Admin:
      component = <AdditionalInformation />;
      break;
    default:
      component = <NotFoundPage />;
      break;
  }

  return <div>{component}</div>;
};

export default AdditionalInformationValidation;
